import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, inject } from '@angular/core';
import { KeyTitleModel } from '../../../../models/key-value-model';
import { ArticleBlock } from '../../../../models/article';
import { RestaurantDetails } from '../../../../models/restaurant-details';
import { LoaderService } from '../../../../services/loader.service';
import { BusinessService } from '../../../../services/business.service';
import { BusinessFilter } from '../../../../models/register-business';
import { Editor } from 'ngx-editor';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-article-add-resto-details',
  templateUrl: './article-add-resto-details.component.html',
  styleUrls: ['./article-add-resto-details.component.scss']
})
export class ArticleAddRestoDetailsComponent implements OnInit, OnDestroy {
  @Output() blockElementChange = new EventEmitter<ArticleBlock>();
  @Input() blockElement: ArticleBlock;
  @Input() isShow: boolean = true;
  @Input() restaurantType: any;
  typeSelect: KeyTitleModel;
  restaurantDetailsList: any[] = [];
  businessFilter = new BusinessFilter();
  types: KeyTitleModel[] = [];
  editorControl = new FormControl();
  editor!: Editor;
  private removeListenerFn: () => void;
  displayHtml: SafeHtml;

  constructor(
    private loaderService: LoaderService,
    private businessService: BusinessService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.editor = new Editor();
    this.loadData();
  }

  loadData() {
    this.loaderService.setLoading(true);
    this.businessFilter.offset = 0;
    this.businessFilter.limit = 1000;
    this.businessFilter.timeZoneOffset = new Date().getTimezoneOffset();

    this.businessService.getBusinessList(this.businessFilter)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response && response.records) {
            this.restaurantDetailsList = response.records;
            this.types = response.records.map((item) => ({
              id: item.branchId,
              title: item.name,
            }));
          }

          if (this.restaurantType) {
            this.typeSelect = this.restaurantType;
          }
          else {
            this.typeSelect = this.extractText(this.blockElement.data);
          }
          this.routeToRestaurant();
          this.loaderService.setLoading(false);
        },
        error: () => {
          this.loaderService.setLoading(false);
        }
      });
  }

  private modalService = inject(NgbModal);
  routeToRestaurant() {
    const dataHtml = this.getSanitizedHtml(this.blockElement.data);
    this.displayHtml = this.sanitizer.bypassSecurityTrustHtml(dataHtml);
    this.cdr.detectChanges();
    const modalEle = this.elRef.nativeElement;
    this.removeListenerFn = this.renderer.listen(modalEle, 'click', (event) => {
      const target = event.target as HTMLElement;
      if (target && target.classList.contains('branch-link')) {
        event.preventDefault();
        const branchId = target.getAttribute('data-branch-id');
        if (branchId) {
          this.router.navigate(['/business-detail', branchId]);
          this.modalService.dismissAll();
        }
      }
    });;
  }

  onChangeRestaurant(event: any) {
    const restoDetails = this.restaurantDetailsList.find(x => x.branchId == event.id);
    if (restoDetails) {
      const addressParts = [restoDetails.address, restoDetails.addressLine2].filter(part => part).join(',');
      const addressParts2 = [restoDetails.cityName, restoDetails.countryName].filter(part => part).join(',');
      const formattedDetails = `
      <h3 class='restro-title'>${restoDetails.name}</h3>
      ${addressParts ? `<p>${addressParts},</p>` : ''}
      ${addressParts2 ? `<p>${addressParts2},</p>` : ''}
      ${restoDetails.zipcode ? `<p>${restoDetails.zipcode}</p>` : ''}
      ${restoDetails.phoneNumber ? `<p><strong>${restoDetails.phoneNumber}</strong></p>` : ''}
      <p>${restoDetails.description}</p>
      `;

      this.editorControl.setValue(formattedDetails);
      this.blockElement.data = formattedDetails;
      this.blockElement.restaurantType = event.title;
      const dataHtml = this.getSanitizedHtml(this.blockElement.data);
      this.displayHtml = this.sanitizer.bypassSecurityTrustHtml(dataHtml);
      this.blockElementChange.emit(this.blockElement);
    }
  }

  onChange(e: string) {
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
    if (this.removeListenerFn) {
      this.removeListenerFn();
    }
  }

  getSanitizedHtml(html: string): string {
    let typeSelect = this.extractText(this.blockElement.data);
    let restaurant = this.restaurantDetailsList.filter(x => x.name == typeSelect);
    let updatedHtml = '';
    if (restaurant.length > 0) {
      let branchId = restaurant[0].branchId;
      updatedHtml = html.replace(/<h3 class='restro-title'>(.*?)<\/h3>/i, `<a href="#" class="branch-link" data-branch-id="${branchId}" style="font-size:18px; font-weight:400; text-decoration:underline; color:#007bff; cursor:pointer">$1</a>`);
      updatedHtml = `<p style="font-size:18px; font-weight:700; margin-bottom:13px"><strong>About the Restaurant</strong></p>\n` + updatedHtml;
      updatedHtml = updatedHtml.replace(/<p>/gi, `<p style="margin-top:13px"></p>`);
    }
    return updatedHtml;
  }

  extractText(htmlString: string): any | null {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const h3Element = doc.querySelector('h3');
    return h3Element ? h3Element.textContent : null;
  }
}
